import { TASK_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { TYPE } from 'customer-data-objects/task/TaskPropertyNames';
import { LINKED_IN } from 'customer-data-objects/engagement/TaskTypes';
const MEETING = 'MEETING';
const EXCLUDED_ENUM_OPTIONS = {
  [TASK_TYPE_ID]: {
    [TYPE]: [MEETING, LINKED_IN]
  }
};
export const getExcludedEnumOptions = (objectTypeId, propertyName) => {
  var _EXCLUDED_ENUM_OPTION, _EXCLUDED_ENUM_OPTION2;
  return (_EXCLUDED_ENUM_OPTION = (_EXCLUDED_ENUM_OPTION2 = EXCLUDED_ENUM_OPTIONS[objectTypeId]) === null || _EXCLUDED_ENUM_OPTION2 === void 0 ? void 0 : _EXCLUDED_ENUM_OPTION2[propertyName]) !== null && _EXCLUDED_ENUM_OPTION !== void 0 ? _EXCLUDED_ENUM_OPTION : [];
};